import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  CoverageQuery,
  Error,
  GetCoverageReport
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  params?: CoverageQuery
  children?: (respone: GetCoverageReport) => ReactElement
  onError?: (error: Error) => void
  onSuccess?: (respone: GetCoverageReport) => void
}

const GetAiModelCoverageRequest = ({
  id,
  params,
  children,
  onError,
  onSuccess
}: Props) => {
  const url = `${AI_API_SERVICE}/models/${id}/coverage`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default GetAiModelCoverageRequest
